import React from 'react'
import IncentiveMultiSelectList from '../baseComponents/incentiveMultiSelectList/IncentiveMultiSelectList';

export const UserSelection = (props: { stateName: string }) => {
    const listOptions = [
        'salesrep','supplier','reportadmin','projectadmin','admin','chief'
    ]
    return (
        <IncentiveMultiSelectList listOptions={listOptions} stateName={props.stateName}/>
    )
}
